import React from 'react';
import parse from 'html-react-parser';
import clsx from 'clsx';
import * as styles from './Holder.module.scss';

const Holder = React.forwardRef((props, ref) => {
  const {
    tag,
    phrase,
    title,
    description,
    type,
    className,
    ...other
  } = props;

  return (
    <div ref={ref} className={clsx(styles.wrapper, className)} {...other}>
      <p className={styles.tag}>{tag}</p>
      <h1 className={styles.phrase}>{parse(phrase)}</h1>
      <p className={styles.title}>{title}</p>
      <p className={styles.description}>{parse(description)}</p>
      <p className={styles.type}>{type}</p>
    </div>
  );
});

export default React.memo(Holder);
